module.exports = __webpack_public_path__ + "static/img/item1.0a59b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item1.png
// module id = kNdw
// module chunks = 0